var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTraininghistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 1.917a.833.833 0 00-1.667 0v1.916H1.917a.833.833 0 00-.834.834v16.5c0 .46.373.833.834.833H9.25a.833.833 0 000-1.666h-6.5V9.167h18.5v1.917a.833.833 0 001.667 0V4.667a.833.833 0 00-.834-.833h-4.666V1.916a.833.833 0 00-1.667 0v1.916h-7.5V1.917zm13 5.583v-2H2.75v2h18.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.417 15.667a.833.833 0 00-1.667 0V17.5c0 .46.373.834.833.834h1.834a.833.833 0 100-1.667h-1v-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.583 12.084a5.417 5.417 0 100 10.833 5.417 5.417 0 000-10.834zm-3.75 5.416a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0z"
  })));
}
export default SvgTraininghistory;